import { has as _has } from "lodash";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ComponentPreparing from "../components/dumb/LoadingInprogress.vue";
import ComponentFailed from "../components/dumb/LoadingFailed.vue";
import elementsInfo from "./elements.json";

dayjs.extend(relativeTime);

// use in async loaded components
export const preloadComp = {
  loadingComponent: ComponentPreparing,
  errorComponent: ComponentFailed,
};

// get specific env variables defined in .env
export const envs = (env) => {
  const prefix = "VUE_APP";
  const val = process.env[`${prefix}_${env}`];
  if (env === "MAP_BASE" && val && !val.endsWith("/")) {
    return `${val}/`;
  }
  return val;
};

// log only when in development mode
export const log = (message) => {
  const isDebugEnabled = false || envs("MODE") === "development";
  if (isDebugEnabled) console.log(message);
};

import { AUTH_STORAGE_KEYS } from "../constants/auth";

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_STORAGE_KEYS.JWT); //check if N/A
};

export const setAuthToken = (token) => {
  return localStorage.setItem(AUTH_STORAGE_KEYS.JWT, token);
};

export const removeAuthToken = () => {
  return localStorage.removeItem(AUTH_STORAGE_KEYS.JWT);
};

export const getRefreshToken = () => {
  return localStorage.getItem(envs("REFRESH_TOKEN") || AUTH_STORAGE_KEYS.REFRESH_TOKEN);
};

export const setRefreshToken = (token) => {
  return localStorage.setItem(envs("REFRESH_TOKEN") || AUTH_STORAGE_KEYS.REFRESH_TOKEN, token);
};

export const removeRefreshToken = () => {
  return localStorage.removeItem(envs("REFRESH_TOKEN") || AUTH_STORAGE_KEYS.REFRESH_TOKEN);
};

export const elementInfo = (element) => {
  for (const nth of elementsInfo.elements) {
    if (nth.symbol === element) return nth.name;
  }
  return null;
};

export const toRelativeTime = (timestamp) => {
  return dayjs().from(timestamp, true).toString() + " ago";
};
